var musicbox = {};
musicbox.config = {};
musicbox.config.timpani = {};
musicbox.config.kit = {};
musicbox.config.woodblock = {};
musicbox.config.conga = {};
